import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CheckCircle2, Loader2, Paperclip, Send } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

export default function SendToTeam() {
  const { ext } = useParams();
  const [who, setWho] = useState(null);
  const [f, setF] = useState({ name: "", email: "", subject: "", message: "" });
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  useEffect(() => { api.get(`/public/send-to/${ext}`).then((r) => setWho(r.data)).catch(() => setWho({ error: true })); }, [ext]);
  const send = async (e) => {
    e.preventDefault();
    setBusy(true);
    const fd = new FormData();
    Object.entries(f).forEach(([k, v]) => fd.append(k, v));
    if (file) fd.append("file", file);
    try { await api.post(`/public/send-to/${ext}`, fd); setDone(true); } catch (er) { toast.error(formatApiError(er)); } finally { setBusy(false); }
  };
  const inp = (k, ph, type = "text") => <input type={type} required value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} placeholder={ph} className="input-luxe" data-testid={`send-${k}`} />;
  return (
    <div className="min-h-screen bg-[var(--bg)] flex items-center justify-center p-6" data-testid="send-to-team-page">
      <div className="w-full max-w-lg bg-white border border-[var(--line)] rounded-3xl p-8 shadow-xl">
        <p className="text-xs uppercase tracking-[0.22em] text-[var(--gold)]">Locked In Forever</p>
        {!who ? <Loader2 className="w-6 h-6 animate-spin text-[var(--gold)] mt-6" /> : who.error ? <h1 className="font-serif text-3xl mt-2">This link isn't valid</h1>
          : done ? <div className="text-center py-6" data-testid="send-done"><CheckCircle2 className="w-12 h-12 text-[var(--gold)] mx-auto" /><h1 className="font-serif text-3xl mt-3">Sent to {who.name}</h1><p className="text-sm text-[#5c544b] mt-2">They'll reply to your email soon.</p></div>
          : <form onSubmit={send} className="space-y-3 mt-2">
            <h1 className="font-serif text-3xl">Send something to {who.name}</h1>
            <p className="text-sm text-[#5c544b]">Messages and files go straight to their inbox.</p>
            {inp("name", "Your name")}{inp("email", "Your email", "email")}{inp("subject", "Subject")}
            <textarea rows={5} value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} placeholder="Your message" className="input-luxe" data-testid="send-message" />
            <label className="text-sm font-semibold inline-flex items-center gap-2 cursor-pointer" data-testid="send-file"><Paperclip className="w-4 h-4" />{file ? file.name : "Attach a file (PDF, photo, Word, Excel)"}<input type="file" hidden onChange={(e) => setFile(e.target.files?.[0] || null)} /></label>
            <button disabled={busy} className="btn-gold w-full disabled:opacity-50" data-testid="send-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}Send</button>
          </form>}
      </div>
    </div>
  );
}
